import { useState } from 'react';
import fanIcon from '../Assets/fan.png';
import './App.css';

const SPLASH_QUOTES = [
  'A PC is the ultimate bicycle for the mind',
  'One PC, endless possibilities.',
  'Your PC deserves the best.',
  "Build the PC you've always wanted.",
  'Power your world with the perfect PC.',
  'The PC that keeps up with you.',
  'A PC is where ideas become reality.',
  'A PC is the canvas of modern creativity.',
  'A PC is the engine behind every dream.',
  "A PC is not a machine; it's a possibility.",
  'A PC is the bridge between imagination and innovation.',
  'A PC is the tool that shapes tomorrow.',
  'A PC is where ambition finds power.',
  'A PC is the spark behind great ideas.',
];

function App() {
  const [quote] = useState(() => SPLASH_QUOTES[Math.floor(Math.random() * SPLASH_QUOTES.length)]);

  return (
    <div className="App">
      <header className="App-header">
        <img src={fanIcon} className="App-logo" alt="Loading" />
        <div className="splash-quote-wrap">
          {/* Invisible copy reserves the exact box size so the visible text never shifts as it types in */}
          <p className="splash-quote-ghost" aria-hidden="true">{quote}</p>
          <p className="splash-quote-reveal" style={{ '--splash-steps': quote.length }}>{quote}</p>
        </div>
      </header>
    </div>
  );
}

export default App;
